import { useAuth as useClerkAuth, useUser, useClerk } from "@clerk/clerk-react";
import { useAuth0 } from "@auth0/auth0-react";
import { getRuntimeAuthProvider } from "@/config/auth";
import { clearAuth0SupabaseToken } from "@/services/auth0-token";
import { clearAuth0IdentityLinkCache } from "@/services/auth0-identity-link";
import { openAuthRedirect } from "@/utils/authRedirect";

export function useProviderAuth() {
  const mode = getRuntimeAuthProvider();
  const clerkAuth = useClerkAuth();
  const clerkUser = useUser();
  const clerk = useClerk();
  const auth0 = useAuth0();

  if (mode === "auth0") {
    return {
      provider: mode,
      isLoaded: !auth0.isLoading,
      isSignedIn: auth0.isAuthenticated,
      user: auth0.user ?? null,
      signIn: (returnTo?: string) =>
        auth0.loginWithRedirect({
          appState: { returnTo: returnTo ?? "/dashboard" },
          openUrl: openAuthRedirect,
        }),
      signUp: (returnTo?: string) =>
        auth0.loginWithRedirect({
          appState: { returnTo: returnTo ?? "/dashboard" },
          authorizationParams: { screen_hint: "signup" },
          openUrl: openAuthRedirect,
        }),
      signOut: async (returnTo = window.location.origin) => {
        clearAuth0SupabaseToken();
        clearAuth0IdentityLinkCache();
        sessionStorage.removeItem("active_auth_provider");
        await auth0.logout({
          logoutParams: { returnTo },
          openUrl: openAuthRedirect,
        });
      },
    };
  }

  return {
    provider: mode,
    isLoaded: clerkAuth.isLoaded && clerkUser.isLoaded,
    isSignedIn: Boolean(clerkAuth.isSignedIn && clerkUser.user),
    user: clerkUser.user ?? null,
    signIn: async (returnTo?: string) => {
      sessionStorage.setItem("redirect_after_login", returnTo ?? "/dashboard");
      window.location.href = "/clerklogin";
    },
    signUp: async (returnTo?: string) => {
      sessionStorage.setItem("redirect_after_login", returnTo ?? "/dashboard");
      window.location.href = "/clerklogin";
    },
    signOut: async () => {
      sessionStorage.removeItem("active_auth_provider");
      await clerk.signOut(() => {
        window.location.href = "/";
      });
    },
  };
}
